import styles from "./Location.module.css";
import locationBackgroundImg from "../../assets/images/contact-main.png";
import SocialLink from "../UI/SocialLink";
import whatsappImg from "../../assets/icons/whatsapp-dark.png";
import facebookImg from "../../assets/icons/facebook-dark.png";
import instagramImg from "../../assets/icons/instagram-dark.png";

const Location = () => {
  return (
    <section
      className={styles.section}
      style={{ backgroundImage: `url(${locationBackgroundImg})` }}
    >
      <div className={styles["wrapper--1"]}>
        <div className={`${styles.container} ${styles["container--1"]}`}>
          <h4 className={styles.title}>
            We Are <br className={styles.break} /> Located At!!!!
          </h4>
        </div>
        <div className={`${styles.container} ${styles["container--2"]}`}>
          <h5 className={styles.subtitle}>Address</h5>
          <p className={styles.content}>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea,
            accusamus, nemo animi aspernatur libero error omnis sed quidem
            tempore architecto, quas tempora nam nostrum expedita?
          </p>
        </div>
      </div>
      <div className={styles["wrapper--1"]}>
        <div className={`${styles.container} ${styles["container--1"]}`}>
          <h4 className={styles.title}>
            Contact <br className={styles.break} /> Details
          </h4>
        </div>
        <div className={`${styles.container} ${styles["container--2"]}`}>
          <h5 className={styles.subtitle}>Address</h5>
          <p className={styles.content}>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea,
            accusamus, nemo animi aspernatur libero error omnis sed quidem
            tempore architecto, quas tempora nam nostrum expedita?
          </p>
        </div>
      </div>
      <div className={`${styles["wrapper--1"]} ${styles["wrapper-link"]}`}>
        <h5 className={styles.subtitle}>Social Media Links</h5>
        <div className={styles.linksContainer}>
          <SocialLink
            linkClassName={styles.linkBtn}
            href="#"
            src={whatsappImg}
            alt="whatsapp"
          />
          <SocialLink
            linkClassName={styles.linkBtn}
            href="#"
            src={instagramImg}
            alt="instagram"
          />
          <SocialLink
            linkClassName={styles.linkBtn}
            href="#"
            src={facebookImg}
            alt="facebook"
          />
        </div>
      </div>
      <div className={`${styles["wrapper--1"]} ${styles["wrapper-event"]}`}>
        <h5 className={styles.subtitle}>
          Event Related Information...................
        </h5>
      </div>
    </section>
  );
};

export default Location;
